import { Entity } from "../helpers/Entity"
import ExternalShippingMethod from "./ExternalShippingMethod"
import { TYPE_LATE_FEE } from "./feeTypes"

export type FeeAttributes = {
    name: string,
    rate: string,
    isDefault: boolean,
    isDefaultLateFee: boolean,
    taxExempt: boolean,
    accountId: string,
    externalProducts: [],
    rateType: string,
    externalShippingMethods: [],
    isShippingFee: boolean,
    daysAfterDueDate: string,
    feeType: string,
}

export type FeeDto = {
    id: string
    type: string
    attributes: FeeAttributes
}

export default class Fee implements Entity {
    private dto: FeeDto

    constructor(dto: FeeDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.id != "" && (this.dto.type == "fees" || this.dto.type == "late-fees")

    }

    getId(): string {
        return this.dto.id
    }

    getName(): string {
        return this.dto.attributes.name
    }

    getRate(): string {
        return this.dto.attributes.rate
    }

    isDefault(): boolean {
        return this.dto.attributes.isDefault
    }

    isTaxExempt(): boolean {
        return this.dto.attributes.taxExempt
    }

    getAccountId(): string {
        return this.dto.attributes.accountId
    }

    getExternalProducts() {
        return this.dto.attributes.externalProducts
    }

    getRateType(): string {
        return this.dto.attributes.rateType
    }

    getExternalShippingMethods(): ExternalShippingMethod[] {
        return this.dto.attributes.externalShippingMethods.map(sm => new ExternalShippingMethod(sm))
    }

    isShippingFee(): boolean {
        return this.dto.attributes.isShippingFee
    }

    getDaysAfterDueDate(): number {
        return parseInt(this.dto.attributes.daysAfterDueDate) || 0
    }

    isLateFee(): boolean {
        return this.dto.attributes.feeType === TYPE_LATE_FEE
    }
}


// WEBPACK FOOTER //
// ./src/state/fee/Fee.ts